import React,{useState,useEffect}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message,} from 'antd';
import {useAllPhotoQuery, usePhotoAlbumDelMutation,} from '../../store/ReactWebSiteApi';
import ModalDel from '../../cpn/ModalDel';
function AlbumStudentGroup() {
    const {data, isSuccess} = useAllPhotoQuery();    
    const [list, setList] = useState();    
    useEffect(() => {
        if (isSuccess) {
            //console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {epa_id:key,admin,epa_name,epa_s_date,epa_content,epa_uname,epa_ctime,epa_e_date,epa_zb_company,epa_xb_company,epa_group_name} = item;
                    return item = {key,admin,epa_name,epa_s_date,epa_content,epa_uname,epa_ctime,epa_e_date,epa_zb_company,epa_xb_company,epa_group_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.epa_ctime;
                    let bTimeString = b.epa_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
        {
            key: 'epa_typepa_id',
            title: '名称',
            dataIndex:'epa_name',
           
        },      
        {
            key: 'epa_content',
            title: '备注',
            dataIndex:'epa_content',
           
        },      
        {
            key: 'epa_s_date',
            title: '起止日期',
            dataIndex:'epa_content',
            render:(_,record) => {
                return <>{record.epa_s_date+" 至 "+record.epa_e_date}</>
            }
           
        },      
        
        {
            key: 'time',
            title: '创建/修改时间',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.epa_ctime + record.epa_uname}</div>
                    <div>修改时间：</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space >                       
                        <ModalDel onOk={() => {
                            del({epa_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                    </Space>
                </>
            }
        },
    ]
 
     //删除
     const [del] = usePhotoAlbumDelMutation()
    return (
        <Main  t1='数据' n1='/DataIndex' t2='旅当家' n2='/LvdangjiaIndex' t3='研学组团' n3='/StudentGroupIndex' t4='研学相册'>
            <Table columns={columns} dataSource={list} style={{marginTop:"10px"}}></Table>
        </Main>
    )
}

export default AlbumStudentGroup